import React from 'react';

import CardActions from '@material-ui/core/CardActions';
import CircularProgress from '@material-ui/core/CircularProgress';
import clsx from 'clsx';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { useDispatch, useSelector } from 'react-redux';

import Icons from 'consts/icons';
import { addAlert } from 'store/actions/alert/alerts';
import { authGetRequest } from 'helpers/apiRequests';

import {
  hasArrayElements,
  hasObjectKeys,
  returnElementAppearingOnceInArray,
} from 'utils/main';

import { formStyles } from 'consts/styles/Form';
import OrganizationsTreeView from './OrganizationsTreeView/OrganizationsTreeView';
import useOrganizationsStyles from './ExistingOrganizationsUseSharedStyles';

const ExistingOrganizations = props => {
  const { onParentOrganizationSelect, onOrganizationToEditSelect } = props;
  const dispatch = useDispatch();

  const formClasses = formStyles();

  const organizationsClasses = useOrganizationsStyles();

  const [organizations, setOrganizations] = React.useState([]);
  const [headOrganization, setHeadOrganization] = React.useState({});
  const useString = () => {
    const language = useSelector(state => state.language);
    return language;
  };
  const [subtitles] = React.useState(useString().adminZone);
  const [childArray, setChildArray] = React.useState([]);
  const alertSubtitles = useString().alerts;
  const [expandedCards, setExpandedCards] = React.useState({});
  const canSetState = React.useRef(true);

  const apiRequestHandler = () => {
    authGetRequest('organizations').then(result => {
      if (canSetState.current)
        if (result.status === 200) {
          setOrganizations(result.data);
        } else {
          dispatch(
            addAlert({
              title: alertSubtitles[result.data.code].title_,
              desc: alertSubtitles[result.data.code].desc_,
              type: 'error',
            })
          );
        }
    });
  };

  const cleanUp = () => {
    setOrganizations([]);
    canSetState.current = false;
  };

  React.useEffect(() => {
    apiRequestHandler();
    return () => cleanUp();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (!hasArrayElements(organizations)) return;
    setHeadOrganization(findMasterElement());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organizations]);

  React.useEffect(() => {
    if (hasObjectKeys(headOrganization)) {
      headOrganization.parent = null;
      reorganizeChildrens(headOrganization);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [headOrganization]);

  const findMasterElement = () => {
    let masterElement = false;
    masterElement = organizations.find(x => x.parent === null);

    if (masterElement) return masterElement;

    return findChildrenParentElement();
  };

  const findChildrenParentElement = () => {
    const element = returnElementAppearingOnceInArray(organizations);
    if (element !== undefined) {
      element.parent = null;

      return element;
    }
  };

  const reorganizeChildrens = (parentOrganization = {}) => {
    const childrenOrganizations = organizations.filter(
      x => x.parent === parentOrganization.uid
    );
    let allGrandChildOrganizations = [];

    for (const childOrganization of childrenOrganizations) {
      allGrandChildOrganizations = organizations.filter(
        x => x.parent === childOrganization.uid
      );
      childOrganization.grandChildOrganizations = allGrandChildOrganizations;
    }

    setChildArray(childrenOrganizations);
  };

  const handleExpandClickChildren = (uid = '') => {
    setExpandedCards({
      ...expandedCards,
      [uid]: !expandedCards[uid],
    });
  };

  const handleLoadingOrganization = () => (
    <Typography
      variant="h1"
      component="h2"
      gutterBottom
      className={`${formClasses.Form}--flex ${formClasses.Form}--flex--center`}
    >
      <CircularProgress className={`${formClasses.Form}__switch`} size={30} />
    </Typography>
  );

  return hasObjectKeys(headOrganization) ? (
    <>
      <OrganizationsTreeView
        organization={headOrganization}
        headOrganizationParent={headOrganization}
        handleExpandClickChildren={handleExpandClickChildren}
        expandedCards={expandedCards}
        childArray={childArray}
        onOrganizationToEditSelect={onOrganizationToEditSelect}
        onParentOrganizationSelect={onParentOrganizationSelect}
      ></OrganizationsTreeView>
      {childArray.length > 0 && (
        <div>
          <CardActions
            className={`${formClasses.Form}__card ${formClasses.Form}__card--box-shadow ${formClasses.Form}__text-field--black ${formClasses.Form}__tabs__button`}
            onClick={() => handleExpandClickChildren(headOrganization.uid)}
            disableSpacing
          >
            <Typography variant="h5">
              {subtitles.addOrganization.existingOrgs.expandTitleSlaves_}
            </Typography>
            <IconButton
              className={clsx(
                `${organizationsClasses.ExistingWithTree}__expand-bar__arrow`,
                {
                  [`${organizationsClasses.ExistingWithTree}__expand-bar__arrow--open`]: expandedCards[
                    headOrganization.uid
                  ],
                }
              )}
              aria-expanded={
                headOrganization.grandChildOrganization
                  ? [
                      `expandedCards${headOrganization.grandChildOrganization[0].uid}`,
                    ] || false
                  : [`expandedCards${headOrganization.uid}`] || false
              }
              aria-label="show more"
            >
              <Icons.Navigation.Down />
            </IconButton>
          </CardActions>
          <Collapse in={expandedCards[headOrganization.uid]}>
            {childArray.map((eachChildrenLevel2, index) => (
              <div key={index}>
                <OrganizationsTreeView
                  organization={eachChildrenLevel2}
                  childArray={childArray}
                  handleExpandClickChildren={handleExpandClickChildren}
                  expandedCards={expandedCards}
                  onOrganizationToEditSelect={onOrganizationToEditSelect}
                  onParentOrganizationSelect={onParentOrganizationSelect}
                ></OrganizationsTreeView>
              </div>
            ))}
          </Collapse>
        </div>
      )}
    </>
  ) : (
    handleLoadingOrganization()
  );
};

ExistingOrganizations.propTypes = {
  onParentOrganizationSelect: PropTypes.func.isRequired,
  onOrganizationToEditSelect: PropTypes.func.isRequired,
};

export default ExistingOrganizations;
